import React, { useEffect, useState } from "react"
import "./index.scss"
import Loader from "react-loaders"
import Slider from "./Slider"
import slides from "./album.json"
import AnimatedLetters from "../AnimatedLetters"

const Activities = () => {
  const [letterClass, setLetterClass] = useState("text-animate")

  useEffect(() => {
    const timerId = setTimeout(() => {
      setLetterClass("text-animate-hover")
    }, 3000)

    return () => {
      clearTimeout(timerId)
    }
  }, [])

  return (
    <>
      <section
        className="activities-page-title"
        aria-labelledby="activities-page-title"
      >
        <h1 id="activities-page-title">
          <AnimatedLetters
            letterClass={letterClass}
            strArray={[
              "M",
              "e",
              "s",
              " ",
              "A",
              "c",
              "t",
              "i",
              "v",
              "i",
              "t",
              "é",
              "s",
            ]}
            index={15}
          />
        </h1>
      </section>

      <div
        className="slide-container"
        aria-labelledby="activities-section-title"
      >
        <header className="activities-header">
          <p className="activities-overline">Moments forts du portfolio</p>
          <h2 id="activities-section-title">Activités & Moments de terrain</h2>
          <p className="activities-intro">
            Une histoire visuelle de leadership, d'evenements et de realisations
            techniques qui ont marqué mon parcours.
          </p>
        </header>

        <Slider slides={slides} />
      </div>

      <Loader type="pacman" />
    </>
  )
}

export default Activities
